export default "__VITE_ASSET__71772a60__"